import React from "react";
import "./styles/statusIndicator.css";

const StatusIndicator = ({ status = "available", message }) => {
	const statusConfig = {
		available: {
			color: "#10b981",
			label: "Available for new opportunities",
			icon: "●"
		},
		busy: {
			color: "#f59e0b", 
			label: "Currently engaged",
			icon: "●"
		},
		unavailable: {
			color: "#ef4444",
			label: "Not available",
			icon: "●"
		}
	};

	const currentStatus = statusConfig[status];

	return (
		<div className="status-indicator">
			<div className="status-dot-container">
				<span 
					className="status-dot"
					style={{ color: currentStatus.color }}
				>
					{currentStatus.icon}
				</span>
				<span className="status-pulse" style={{ backgroundColor: currentStatus.color }}></span>
			</div>
			<span className="status-text">
				{message || currentStatus.label}
			</span>
		</div>
	);
};

export default StatusIndicator;